module.exports = __webpack_public_path__ + "static/img-client-03-d00878e5d08bae5b13b9cd2966a9b77b.png";